// extracted by mini-css-extract-plugin
export default {"list":"OZXHz","item":"wXImM","icon":"awCRv"};